import { render, staticRenderFns } from "./IcoFlagTriangle.vue?vue&type=template&id=00f5d2f3"
import script from "./IcoFlagTriangle.vue?vue&type=script&lang=js"
export * from "./IcoFlagTriangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports